import { Injectable } from '@angular/core';

@Injectable()
export class FraudAwarenessBannerService {
    private bannerIndexKey = 'banner-index';
    banners = [
      { id: 1, src: '../../../../assets/imgs/banners/fraud-awareness-banner-1.svg' },
      { id: 2, src: '../../../../assets/imgs/banners/fraud-awareness-banner-2.svg' },
      { id: 3, src: '../../../../assets/imgs/banners/fraud-awareness-banner-3.svg' },
      { id: 4, src: '../../../../assets/imgs/banners/fraud-awareness-banner-4.svg' }
    ];
  
    constructor() {}
  
    getBanner() {
      let currentIndex = parseInt(sessionStorage.getItem(this.bannerIndexKey) || '0', 10);
  
      const banner = this.banners[currentIndex];
  
      const nextIndex = (currentIndex + 1) % this.banners.length;
      
      sessionStorage.setItem(this.bannerIndexKey, nextIndex.toString());
  
      return banner;
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/fraud-awareness-banner/fraud-awareness-banner.service.ts